import { useEffect, useState } from "react";
import api from "../../services/api";

export default function ToothPanel({toothId}) {

  const [tooth,setTooth] = useState(null);

  useEffect(()=>{

    if(!toothId) return;

    api.get(`/teeth/${toothId}`)
       .then(res => setTooth(res.data));

  },[toothId]);

  if(!tooth) return null;

  return(

    <div style={{
      width:300,
      background:"#fff",
      borderLeft:"1px solid #ddd",
      padding:20
    }}>

      <h3>{tooth.name}</h3>

      <p>{tooth.description}</p>

      <ul>
        <li>Roots: {tooth.roots}</li>
        <li>Canals: {tooth.canals}</li>
        <li>Enamel</li>
        <li>Dentin</li>
        <li>Pulp</li>
      </ul>

    </div>

  );

}